import {getFormValues, AccountParams, Error as PaymentMethodTabError} from "./payment-methods-tabs"
import * as $ from "jquery"
import {CommandCaller} from "../lib/commands"
import {showDialog, hideDialog} from "../legacy/modal"
import * as creditCard from "./credit-card"

let showError = (tryParams: AccountParams /*under TS2, "tryParams: PaymentMethodTabError". the if check around usages will effect a safe downcast */) => {
	const error = tryParams as PaymentMethodTabError //delete this cast
	window.alert(error.title + "\n\n" + error.error)
}

export const submit = ( div: JQuery, ajaxPageUrl: string ) => {
	const tryParams = getFormValues(div.find( 'form' ))

	if(tryParams.method == 'error') {
		showError(tryParams)
		return false
	}

	const params = { ...tryParams,
		preferredPaymentDay: $( "[name='PreferredPaymentDay']" ).val(),
		frequency: $( "[name='PaymentFrequency']" ).val()
	}

	div.block({message: "Please wait while your payment is set up..."})

	;(new CommandCaller(ajaxPageUrl).runPost(
		'submit recurring payment',
		params
	) as Promise<string>).then((l: string) => location.assign(l), () => div.unblock())

	return true
}

export const changeDetails = async (form: JQuery, paymentSchedule: string, ajaxPageUrl: string) => {
	const params = { ...getFormValues( form ), paymentSchedule: paymentSchedule }
	if(params.method == 'error') {
		showError(params)
		return
	}

	const body = $(document.body)
	body.block({message: "Please wait while we update the payment details"})

	try {
		await new CommandCaller(ajaxPageUrl).runPost(
			'change payment method',
			params
		)

		hideDialog('ChangePaymentsDialog');
		location.reload();
	} catch (e) {
	}
	body.unblock()
}

export const updateMethod = (
	ajaxPage: string,
	orderId: string,
	paymentMethod: 'CreditCard' | 'DirectDebit',
	preferredPaymentDay: string,
	frequency: string /* a narrower type is possible*/,
	callback?: () => void
) => {
	const type = creditCard.creditCardType().new_
	const params = {
		orderId: orderId,
		paymentMethod: paymentMethod,
		preferredPaymentDay: preferredPaymentDay,
		frequency: frequency,
		cardType: paymentMethod == "CreditCard" && type != null ? type.code : undefined
	}

	const p= new CommandCaller(ajaxPage).runPost('update payment method', params)
	if(callback) p.then(callback)
	return p
}

export const updateCreditCardType = (ajaxPage: string, orderId: string, cardType: CreditCardTypeParams, preferredPaymentDay: string, frequency: string, callback?: () => void ) => {
	const p = new CommandCaller(ajaxPage).runPost(
		'update credit card type',
		{ orderId: orderId, cardType: cardType.code, preferredPaymentDay: preferredPaymentDay, frequency: frequency })
	if (callback) p.then(callback)
	return p
}



// WEBPACK FOOTER //
// ./src/paymentgateway/scheduled-payments.ts